import useEmit from '../../../composables/useEmit'
import type { RouteLocationRaw } from 'vue-router'

export type NotificationVariant = 'success' | 'warning' | 'info'

export type NotificationIcon =
  | 'CheckCircleIcon'
  | 'ExclamationCircleIcon'
  | 'InformationCircleIcon'

export interface NotificationLink {
  to: RouteLocationRaw
  text: string
}

export interface NotificationTextPart {
  text: string
  link?: NotificationLink
}

export interface NotificationOptions {
  delay?: number | null
}

export interface NotificationPayload {
  heading: string
  text?: string | NotificationTextPart[]
  variant: NotificationVariant
  icon: NotificationIcon
  delay?: number | null
}

const emitter = useEmit()

export default { name: 'AppNotification' }

export function useNotification() {
  function notifySuccess(
    heading: string,
    text?: string | NotificationTextPart[],
    options: NotificationOptions = {},
  ) {
    emitter.emit('notify', {
      heading,
      ...(text ? { text } : {}),
      variant: 'success',
      icon: 'CheckCircleIcon',
      ...options,
    })
  }

  function notifyWarning(
    heading: string,
    text?: string | NotificationTextPart[],
    options: NotificationOptions = {},
  ) {
    emitter.emit('notify', {
      heading,
      ...(text ? { text } : {}),
      variant: 'warning',
      icon: 'ExclamationCircleIcon',
      ...options,
    })
  }

  function notifyInfo(
    heading: string,
    text?: string | NotificationTextPart[],
    options: NotificationOptions = {},
  ) {
    emitter.emit('notify', {
      heading,
      ...(text ? { text } : {}),
      variant: 'info',
      icon: 'InformationCircleIcon',
      ...options,
    })
  }

  return {
    notifySuccess,
    notifyWarning,
    notifyInfo,
  }
}
